import { render, staticRenderFns } from "./UserPhoto.vue?vue&type=template&id=33d3c9ac"
import script from "./UserPhoto.vue?vue&type=script&lang=js"
export * from "./UserPhoto.vue?vue&type=script&lang=js"
import style0 from "./UserPhoto.vue?vue&type=style&index=0&id=33d3c9ac&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports